import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white border-t border-neon-cyan/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-neon-pink to-neon-cyan rounded-lg flex items-center justify-center shadow-neon-pink">
                <i className="ri-gamepad-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-neon-pink via-neon-cyan to-neon-green bg-clip-text text-transparent">
                ROX GAMES
              </span>
            </div>
            <p className="text-gray-400 text-sm">
              Sua loja gamer de confiança para hardware e periféricos de alta performance.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-neon-cyan font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/catalogo" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Catálogo
                </Link>
              </li>
              <li>
                <Link to="/monte-seu-pc" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Monte seu PC
                </Link>
              </li>
            </ul>
          </div>

          {/* Categorias */}
          <div>
            <h3 className="text-neon-cyan font-semibold mb-4">Categorias</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Placas de Vídeo
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Processadores
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Periféricos
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                  Monitores
                </a>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-neon-cyan font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-400">
                <i className="ri-mail-line text-neon-green"></i>
                <a href="mailto:contato@roxgames.com" className="text-sm hover:text-neon-cyan transition-colors cursor-pointer">
                  contato@roxgames.com
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <i className="ri-phone-line text-neon-green"></i>
                <a href="tel:+5511999999999" className="text-sm hover:text-neon-cyan transition-colors cursor-pointer">
                  (11) 9999-9999
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <i className="ri-map-pin-line text-neon-green"></i>
                <span className="text-sm">São Paulo, SP</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-neon-pink transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-neon-cyan transition-colors cursor-pointer">
                <i className="ri-facebook-circle-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-neon-green transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 ROX GAMES. Todos os direitos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            className="text-gray-400 hover:text-neon-cyan text-sm transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
